import { createSelector } from "@reduxjs/toolkit";
import selectActivityTypes from "store/selectors/selectActivityTypes";

export default createSelector(selectActivityTypes, (activityTypes) => {
  return activityTypes.map((type) => type.color);
});
